var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-layout",
        { attrs: { row: "", "justify-center": "" } },
        [
          _c(
            "v-dialog",
            {
              attrs: { persistent: "", "max-width": "320" },
              model: {
                value: _vm.dialog,
                callback: function($$v) {
                  _vm.dialog = $$v
                },
                expression: "dialog"
              }
            },
            [
              _c(
                "v-card",
                {
                  class: [
                    { session_expired: _vm.sessionExpired },
                    {
                      "logout-success":
                        _vm.brandKey === "sb" && !_vm.sessionExpired
                    }
                  ]
                },
                [
                  _vm.pageLoader
                    ? _c("div", [_c("circle-loader")], 1)
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.pageLoader && _vm.brandKey !== "sb"
                    ? [
                        !_vm.sessionExpired
                          ? _c("v-card-title", { staticClass: "headline" }, [
                              _vm._v(
                                _vm._s(_vm.$t("Account.Logout.successful"))
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.sessionExpired
                          ? _c("v-card-title", { staticClass: "headline" }, [
                              _vm._v(_vm._s(_vm.$t("Account.Logout.session")))
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "v-card-actions",
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "primary-btn-blue",
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.goToHome()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("Account.Logout.successful.ok"))
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.pageLoader && _vm.brandKey === "sb"
                    ? [
                        !_vm.sessionExpired
                          ? [
                              _c("img", {
                                attrs: {
                                  src: _vm.mediaServer(
                                    "/static/brand-img/sb/SB_" +
                                      _vm.state +
                                      ".png"
                                  ),
                                  alt: "sb"
                                }
                              }),
                              _vm._v(" "),
                              !_vm.sessionExpired
                                ? _c(
                                    "v-card-title",
                                    { staticClass: "headline" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("Account.Logout.successful")
                                        )
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", { staticClass: "comeback" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("Account.Logout.session.comeback")
                                  )
                                )
                              ])
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.sessionExpired
                          ? [
                              _c("img", {
                                attrs: {
                                  src: _vm.mediaServer(
                                    "/static/brand-img/sb/SB_" +
                                      _vm.state +
                                      ".png"
                                  ),
                                  alt: "sb"
                                }
                              }),
                              _vm._v(" "),
                              _c("v-card-title", { staticClass: "headline" }, [
                                _vm._v(_vm._s(_vm.$t("Account.Logout.session")))
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "comeback" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("Account.Logout.session.comeback")
                                  )
                                )
                              ])
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "v-card-actions",
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "primary-btn-blue",
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.goToHome()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("Account.Logout.successful.ok"))
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.brandKey === "sb" && _vm.state === "NJ"
                          ? _c(
                              "v-card",
                              { staticClass: "logout-success rg-txt" },
                              [
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$t("Logout.InfoMessage." + _vm.state)
                                    )
                                  }
                                })
                              ]
                            )
                          : _vm._e()
                      ]
                    : _vm._e()
                ],
                2
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-04c50494", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04c50494","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/LogoutPage.vue
// module id = null
// module chunks = 